
import { Message } from "element-ui";
import { Component, Vue } from "vue-property-decorator";
import { Getter, State } from "vuex-class";
import { logError } from "@/common/LogHelper";
import {
    RootGetterNames,
    RootMutationNames,
    RootState,
    RootStateNames,
} from "@/vuex-store";
import { UserApi } from "@/request/user";
import { IUser } from "@/common/entity/User";
import WxQrCodeLoginPanel from "@/components/wx-qrcode-login-panel/index.vue";

const maxGetConfigsCount = 10;
const intervalGetConfigsS = 1000;

@Component({
    components: { WxQrCodeLoginPanel },
})
export default class index extends Vue {
    getConfigsCount: number = 0;

    get showLoginPanel(): boolean {
        return (this.$store.state as RootState).showLoginPanel;
    }

    set showLoginPanel(show: boolean) {
        this.$store.commit(RootMutationNames.setShowLoginPanel, show);
    }

    @Getter(RootGetterNames.isLogined)
    isLogined!: boolean;

    created() {
        this.getConfigsCount = 0;
        if (this.isLogined) this.reqUserInfo();
        else this.getUserApiConfigs();
    }

    async reqUserInfo() {
        try {
            const user = await UserApi.reqUserInfo(false);
            this.$store.commit(RootMutationNames.setCurrUser, user);
            this.getUserApiConfigs();
        } catch (error) {
            logError("获取用户信息失败", error);
        }
    }

    async getUserApiConfigs() {
        try {
            const apiConfigs = await UserApi.getUserApiConfigs(false);
            this.getConfigsCount = 0;
            this.$store.commit(RootMutationNames.setAppConfigs, apiConfigs);
        } catch (e) {
            this.onGetApiConfigFail();
        }
    }

    onGetApiConfigFail() {
        this.getConfigsCount++;
        if (this.getConfigsCount > maxGetConfigsCount) {
            Message.error({
                message: "加载数据失败，请重新刷新界面",
                type: "error",
                duration: 0,
                showClose: true,
            });
            return;
        }
        setTimeout(() => {
            this.getUserApiConfigs();
        }, intervalGetConfigsS);
    }

    onLoginError(errMsg: string) {
        this.$store.commit(RootMutationNames.setShowLoginPanel, false);
    }

    onLoginSuccess(user: IUser) {
        //更新用户信息
        this.$store.commit(RootMutationNames.setCurrUser, user);
        Message.success("登录成功");
        this.$store.commit(RootMutationNames.setShowLoginPanel, false);
    }
}
